/**
 * PilotFooter component.
 */
import AppLogo from '@components/atoms/images/pilotAppLogo';
import ContentContainer from '@components/atoms/container/pilotFooterContentContainer';
import Event from '@components/elements/pilot/pilotEvent';
import FooterContainer from '@components/atoms/container/pilotFooterContainer';
import Hint from '@components/elements/pilot/pilotHint';
import Info from '@components/elements/pilot/pilotInfo';
import Poster from '@components/elements/pilot/pilotPoster';
import ProgressBar from '@components/elements/pilot/pilotProgressBar';
import Tip from '@components/elements/pilot/pilotTip';
import usePilotFooter from './usePilotFooter';
import { PilotProps as Props } from '@shared/types/props/pilot';

/**
 * Renders the pilot footer components.
 * Displays the pilot event, progress bar, info, tip, poster and app logo.
 */
export default function PilotFooter(parentProps: Props) {
  const { props } = usePilotFooter(parentProps);
  return (
    <FooterContainer>
      {parentProps.hint?.visible ? (
        <Hint {...props.hint} />
      ) : (
        <ContentContainer {...props.content}>
          <Event {...props.event} />
          <ProgressBar {...props.progressBar} />
          <Info {...props.info} />
          <Tip />
          <Poster {...props.poster} />
          <AppLogo />
        </ContentContainer>
      )}
    </FooterContainer>
  );
}
